<template lang="pug">
extends order-layout-add-cell-base.pug
block content
    .list.inset
        .list-item.pointer(v-for="product in productList", :key="product.id", @click="toggleItem(product)")
            .list-left
                span.w-40.avatar
                    img(
                        :src="product.media_urls.length > 0 ? product.media_urls[0].s512 : '/img/slurp-500.png'",
                        alt="Product image"
                    )
            .list-body
                p.pull-right
                    i.material-icons.md-24(:class="{ 'item-checked': itemAdded(product), 'text-muted': !itemAdded(product) }") {{ itemAdded(product) ? 'check_box' : 'check_box_outline_blank' }}
                span._400.block {{ product.name }}
                span.text-muted.text-ellipsis {{ product.description }} &nbsp;
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import addCellMixin from './mixins/order-layout-add-cell';

export default {
    mixins: [addCellMixin],

    computed: {
        ...mapGetters('product', {
            productList: 'products',
            totalRecords: 'totalRecords',
        }),

        options() {
            return this.productList;
        },
    },

    created() {
        this.setItemType('product');
        this.getProducts();
    },

    methods: {
        ...mapActions('product', ['getProductList']),

        getProducts() {
            let options = {
                query: this.query,
                relation: true,
                limit: this.pagination.perPage,
                page: this.pagination.page,
                outlet_id: this.orderLayout.outlet_id,
            };

            this.getProductList(options);
        },

        fetchByQuery: _.debounce(function() {
            this.setPage(1);
            this.$refs.pagination.setPage(1);
            this.getProducts();
        }, 500),

        onPaginate(page) {
            this.setPage(page);
            this.getProducts();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-add-product.vue